import PropTypes from 'prop-types'
import React, {useState} from 'react'
import {
  Text,
  Box,
  Modal,
  ModalBody,
  ModalHeader,
  ModalOverlay,
  ModalContent,
  ModalFooter,
  CloseButton,
  Button,
  Input,
} from '@chakra-ui/react'
import {Trans, useTranslation} from 'react-i18next'
import Checkbox from '../../../components/Checkbox'

const ModalWrapper = ({onClose, headerText, children}) => (
  <ModalContent>
    <ModalHeader>
      <Box display="flex" justifyContent="flex-end" width="100%">
        <CloseButton onClick={onClose} data-testid="close-exclude-modal" />
      </Box>
      <Text textStyle="body-intro-medium">{headerText}</Text>
      <hr />
    </ModalHeader>
    {children}
  </ModalContent>
)

ModalWrapper.propTypes = {
  onClose: PropTypes.func.isRequired,
  headerText: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
}

const ExcludePayerModal = ({
  isOpen,
  onClose,
  customerName,
  exclude,
  success,
}) => {
  const {t} = useTranslation('customers')

  const [confirmed, setConfirmed] = useState(false)

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      {success ? (
        <ModalWrapper
          onClose={onClose}
          headerText={t('customers:Statements.SendStatus.modal.titleSuccess')}
        >
          <ModalBody>
            <Text textStyle="body-copy">
              {t('customers:Statements.SendStatus.modal.confirmationSuccess', {
                customerName,
              })}
            </Text>
          </ModalBody>

          <ModalFooter justifyContent="flex-start">
            <Button onClick={onClose} variant="secondary">
              {t('customers:Statements.SendStatus.modal.closeButton')}
            </Button>
          </ModalFooter>
        </ModalWrapper>
      ) : (
        <ModalWrapper
          onClose={onClose}
          headerText={t('customers:Statements.SendStatus.modal.title')}
        >
          <ModalBody>
            <Text textStyle="body-copy-medium">Customer:</Text>
            <Input value={customerName} mt={5} isReadOnly />
            <Box display="flex" alignItems="start" mt={5}>
              <Checkbox
                isChecked={confirmed}
                onChange={(e) => setConfirmed(e.target.checked)}
                mt={1}
              />
              <Text textStyle="body-small" color="mld.alert.800" ml={4}>
                <Trans
                  t={t}
                  i18nKey="customers:Statements.SendStatus.modal.confirmation"
                  components={{strong: <Text as="span" fontWeight="medium" />}}
                />
              </Text>
            </Box>
          </ModalBody>

          <ModalFooter justifyContent="flex-start">
            <Button
              onClick={exclude}
              variant="primary"
              colorScheme="black"
              isDisabled={!confirmed}
            >
              {t('customers:Statements.SendStatus.modal.confirmButton')}
            </Button>
            <Button onClick={onClose} variant="tertiary">
              {t('customers:Statements.SendStatus.modal.cancelButton')}
            </Button>
          </ModalFooter>
        </ModalWrapper>
      )}
    </Modal>
  )
}

ExcludePayerModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  customerName: PropTypes.string.isRequired,
  exclude: PropTypes.func.isRequired,
  success: PropTypes.bool.isRequired,
}

export default ExcludePayerModal
